// @flow

import {browserHistory} from '../browser-history';

/**
 * @deprecated It will be removed in 6 months 09-12-2025. Use instead methods from react-router-dom(react-router).
 * */
export const includeLocation = (location: string): boolean => browserHistory.location.pathname.startsWith(location);
